import { defineMessages } from 'react-intl';

export default defineMessages({
	errorTitle: {
		defaultMessage: 'Something went wrong',
		description: 'Title shown in the sidebar when an error occurs loading the help center',
		id: 'help.center.management.sidebar.error.title',
	},
	errorDescription: {
		defaultMessage: 'Refresh the page and try again',
		description: 'Message shown in the sidebar prompting the user to refresh and retry',
		id: 'help.center.management.sidebar.error.description',
	},
});
